import { CheckIcon } from '@phosphor-icons/react'

import { AccountBalanceWallet } from '@assets/svgs/AccountBalanceWallet'
import { CurrencyDollarSimple } from '@assets/svgs/CurrencyDollarSimple'
import { currencyMask } from '@utils/masks/currencyMask'
import { InfoIcon } from '@assets/svgs/InfoIcon'
import { PreviewCard } from '../PreviewCard'
import { TooltipExplanation } from '@components/shared/TooltipExplanation/inde'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'

import type { BudgetPreviewsProps } from './types'
import { isDeviationPercentageNegative, isDeviationValueNegative } from './helpers'

const OTHER_EXPENSES_WEEK_COLORS = ['#F7E0E0', '#E8B8C0', '#D48A9A', '#BB5C75', '#9C3F58']
const BUDGET_BORDER = '#7B8794'

export const budgetPreviews = ({ data }: BudgetPreviewsProps) => {
  if (!data) return []

  const deviationSignal = data.deviationPercentage ?? 0
  const isDeviationValueExceeded = isDeviationValueNegative(data.deviationValue)
  const isDeviationPercentageExceeded = isDeviationPercentageNegative(data.deviationPercentage)

  const week = data.currentPreviewNumber ?? 3
  const previewBorderColor = OTHER_EXPENSES_WEEK_COLORS[week - 1] ?? OTHER_EXPENSES_WEEK_COLORS[2]

  return [
    <PreviewCard
      isBudget
      borderColor={BUDGET_BORDER}
      label="Budget"
      percentageValue={`${data.budgetPercentage.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.budgetAmount.toFixed(2))}
      icon={<AccountBalanceWallet />}
      bottomText="Orçamento aprovado"
      infoIcon={
        <TooltipExplanation
          data={[{ label: 'Budget (%) = ', text: '(Orçamento (R$) ÷ Budget de Faturamento (R$)) × 100' }]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      isBudget
      borderColor={previewBorderColor}
      label={!data.currentPreviewNumber ? 'Prévia' : `Prévia ${data.currentPreviewNumber}ª semana`}
      percentageValue={`${data.previewCurrentPercentage?.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.previewCurrentAmount?.toFixed(2))}
      icon={<CurrencyDollarSimple />}
      bottomText="Provisão atual"
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'Prévia (%) = ', text: 'Total Outras Despesas / Total Faturamento x 100' },
            { label: 'Prévia (R$) = ', text: 'Total Outras Despesas (R$)' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      label="Desvio (%)"
      borderColor={OTHER_EXPENSES_WEEK_COLORS[OTHER_EXPENSES_WEEK_COLORS.length - 1]}
      percentageValue={`${data.deviationPercentage?.toFixed(2)}%`.replace('.', ',')}
      value={currencyMask(data.deviationValue?.toFixed(2))}
      icon={deviationSignal === 0 ? <CheckIcon size={24} /> : deviationSignal < 0 ? <TrendingDown /> : <TrendingUp />}
      bottomText={deviationSignal === 0 ? 'Sem desvio' : deviationSignal < 0 ? 'Acima do Budget' : 'Abaixo do Budget'}
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'Desvio (%) = ', text: 'Prévia (%) - Budget (%)' },
            { label: 'Desvio (R$) = ', text: 'Prévia (R$) - Budget (R$)' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
      isNegative={isDeviationPercentageExceeded}
      isValueNegative={isDeviationValueExceeded}
    />
  ]
}
